module.exports = function(users) {
	'use strict'
	users.directive('allUsersDir',allUsersDir);
	allUsersDir.$inject=[];
	function allUsersDir() {
		return {
			template: require('./partial/allusers.html'),
			controller:'allusersController',
			controllerAs:'vmau',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/usersModule/allusers/js/directive/allusersDirective.js
// module id = 633
// module chunks = 0